import { render, staticRenderFns } from "./SummaryWidget.vue?vue&type=template&id=6958f956&scoped=true"
import script from "./SummaryWidget.vue?vue&type=script&lang=ts"
export * from "./SummaryWidget.vue?vue&type=script&lang=ts"
import style0 from "./SummaryWidget.vue?vue&type=style&index=0&id=6958f956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958f956",
  null
  
)

export default component.exports